/* src/app/shared/components/popovers/set-rls-for-test-report-popover/set-rls-for-test-report-popover.component.scss */
ion-content {
  height: 744px !important;
}
/*# sourceMappingURL=set-rls-for-test-report-popover.component-S3YEXKOD.css.map */
